import React from 'react';
import { Link } from 'react-router-dom';

import { company } from '../../data/company';

const Footer = () => {
    return (
        <footer className="gloworks-footer pb-3 pb-lg-4">
            <div className="container">
                <div className="footer-top-line"></div>
                <div className="row align-items-center justify-content-between pt-3 pt-lg-4">

                    <div className="col-12 col-lg-2 mb-5 mb-lg-0">
                        <Link className="text-decoration-none d-flex flex-column align-items-start" to="/">
                            <img className={'w100to75'} src={'/site/assets/img/gloworks-logo.png'} alt={'footer logo'}/>
                        </Link>
                    </div>

                    <div className="col-12 col-lg-6">
                        <div className="d-flex flex-column flex-lg-row align-items-center justify-content-lg-end gap-2 gap-lg-4">
                            <a className="footer-link" href={`mailto:${company.email}`}>
                                {company.email}
                            </a>
                            <Link className="footer-link" to="/contact">Contact</Link>
                            <p className="text-white small mb-0 text-center text-lg-end">
                                &copy; {new Date().getFullYear()} GloworKs. All rights reserved.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;